export const ROUTE_LOGIN = "/login";
export const ROUTE_SIGN_UP_FRESH = "/sign-up/fresh";
